module.exports = __webpack_public_path__ + "img/alone-animate.cd3e3208.svg";